import { render, staticRenderFns } from "./OptionalFeatureEditor.vue?vue&type=template&id=150bffd0&scoped=true&"
import script from "./OptionalFeatureEditor.vue?vue&type=script&lang=ts&"
export * from "./OptionalFeatureEditor.vue?vue&type=script&lang=ts&"
import style0 from "./OptionalFeatureEditor.vue?vue&type=style&index=0&id=150bffd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150bffd0",
  null
  
)

export default component.exports